export default "__VITE_ASSET__06cc78ef__"